import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import type { Dispatch } from '@swf/core/store';
import { GameType, PokerModalRoutes } from '@swf/core/types/Poker';
import { useDeleteCashGame, useDeleteTournament, useHomeGamesWidget } from '@swf/poker';

import styles from './DeleteGame.scss';
import {
  TXTCLI_Are_you_sureX_All_entry_fees_f_ELL,
  TXTCLI_Are_you_sureX_Table_will_close_ELL,
  TXTCLI_Cancel,
  TXTCLI_Cancel_Table,
  TXTCLI_Cancel_Tournament
} from './DeleteGamePrompt.messages.json';

const DeleteGamePrompt: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const {
    state: { clubId, type, widgetId }
  } = useLocation<{
    clubId: number;
    type: string;
    widgetId: string;
  }>();
  const { widgetSelect } = useHomeGamesWidget(widgetId);
  const [gameId] = useSelector(widgetSelect.selectedGames);
  const { handleDeleteCashGame, loading } = useDeleteCashGame(widgetId);
  const { handleDeleteTournament, loading: loadingTournament } = useDeleteTournament(widgetId);
  const isCashGame = type === GameType[GameType['Cash Game']];
  const actionText = isCashGame ? TXTCLI_Cancel_Table : TXTCLI_Cancel_Tournament;
  const promptText = isCashGame
    ? TXTCLI_Are_you_sureX_Table_will_close_ELL
    : TXTCLI_Are_you_sureX_All_entry_fees_f_ELL;

  const handleSubmit = () => {
    if (isCashGame) {
      handleDeleteCashGame({
        body: { hgCancelCashGame: { clubId, tableId: Number(gameId) } }
      });
    }
    if (type === GameType[GameType['Tournament']]) {
      handleDeleteTournament({
        body: { hgCancelTournament: { clubId, tournId: Number(gameId) } }
      });
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        <Translation {...actionText} />
      </p>
      <p className={styles.text}>
        <Translation {...promptText} />
      </p>
      <ButtonGroup className={styles.buttons}>
        <StarsButton
          variant="tertiary"
          disabled={loading || loadingTournament}
          onClick={handleSubmit}
          translation={actionText}
        />
        <StarsButton
          variant="tertiary"
          translation={TXTCLI_Cancel}
          onClick={() => modal.close(PokerModalRoutes.deleteGamePrompt)}
        />
      </ButtonGroup>
    </div>
  );
};

export default DeleteGamePrompt;
